
/*
We're constantly improving the code you see.
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from 'react'

export const DashedLineIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M5.25 11H0.75C0.551088 11 0.360322 10.8946 0.21967 10.7071C0.0790176 10.5196 0 10.2652 0 10C0 9.73478 0.0790176 9.48043 0.21967 9.29289C0.360322 9.10536 0.551088 9 0.75 9H5.25C5.44891 9 5.63968 9.10536 5.78033 9.29289C5.92098 9.48043 6 9.73478 6 10C6 10.2652 5.92098 10.5196 5.78033 10.7071C5.63968 10.8946 5.44891 11 5.25 11Z" fill="black"/>
    <path d="M12.3576 11H7.6424C7.47202 11 7.30863 10.8946 7.18815 10.7071C7.06768 10.5196 7 10.2652 7 10C7 9.73478 7.06768 9.48043 7.18815 9.29289C7.30863 9.10536 7.47202 9 7.6424 9H12.3576C12.528 9 12.6914 9.10536 12.8118 9.29289C12.9323 9.48043 13 9.73478 13 10C13 10.2652 12.9323 10.5196 12.8118 10.7071C12.6914 10.8946 12.528 11 12.3576 11Z" fill="black"/>
    <path d="M19.25 11H14.75C14.5511 11 14.3603 10.8946 14.2197 10.7071C14.079 10.5196 14 10.2652 14 10C14 9.73478 14.079 9.48043 14.2197 9.29289C14.3603 9.10536 14.5511 9 14.75 9H19.25C19.4489 9 19.6397 9.10536 19.7803 9.29289C19.921 9.48043 20 9.73478 20 10C20 10.2652 19.921 10.5196 19.7803 10.7071C19.6397 10.8946 19.4489 11 19.25 11Z" fill="black"/>
    </svg>

  )
}

